module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Ladle-9362a2749b8188815552184494c039c6.svg";